export const zeroPad = value => {
  const normalizedValue = Number(value) || 0;
  return normalizedValue < 10 ? `0${normalizedValue}` : String(normalizedValue);
};

export const formatDateDDMMYYYY = date => {
  const parsedDate = date instanceof Date ? date : new Date(date);
  return `${zeroPad(parsedDate.getDate())}/${zeroPad(parsedDate.getMonth() + 1)}/${parsedDate.getFullYear()}`;
};

export const formatMoneyBRL = value => {
  const moeda = "R$ ";
  const decimais = 2;
  const separadorMilhar = ".";
  const separadorDecimal = ",";

  const numericValue = Number(value) || 0;
  const sinal = numericValue < 0 ? "-" : "";
  const absoluteValue = Math.abs(numericValue);
  const naoFormatado = Number.parseInt((absoluteValue * 10 ** decimais).toFixed(0), 10);
  if (naoFormatado === 0) {
    return `${moeda}0${separadorDecimal}00`;
  }

  let formatado = String(naoFormatado);
  formatado = `${formatado.slice(0, -2)}${separadorDecimal}${formatado.slice(-decimais)}`;
  const tamanhoMaximoSemMilhar = 3 + 1 + decimais;
  for (let index = formatado.length - tamanhoMaximoSemMilhar; index > 0; index -= 3) {
    formatado = `${formatado.slice(0, index)}${separadorMilhar}${formatado.slice(index)}`;
  }
  return `${moeda}${sinal}${formatado}`;
};
